import Grid from '@mui/material/Grid';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../../components/Header/Header';
import TabPanel from '../../components/TabPanel/TabPanel';
import { OvertimeThresholds } from '../types';
import { getACAHoursWorked } from '../utilities/laborUtilities';
import ACAThresholdReportFilters, { ACAThresholdFilters } from './ACAThresholdReportFilters';
import ACAAverageHoursDataGrid from './components/ACAAverageHoursDataGrid';
import ACAHourlyThresholdDataGrid from './components/ACAHourlyThresholdDataGrid';

export const overtimeThresholds: OvertimeThresholds = {
  lowerThreshold: 20,
  middleThreshold: 25,
  upperThreshold: 30,
};

function ACAThresholdReportDashboard() {
  const { t } = useTranslation();
  const [tabPanel, setTabPanel] = useState(0);
  const [filters, setFilters] = useState<ACAThresholdFilters>();
  const [showApproachingHourlyFilters, setShowApproachingHourlyFilters] = useState(true);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabPanel(newValue);
    setShowApproachingHourlyFilters(newValue === 0);
  };

  // memo due to translations needed to create this dictionary, and constant options (For now)
  const { hoursWorked, hoursWorkedOptions } = useMemo(() => getACAHoursWorked(t, overtimeThresholds, false), [t]);

  return (
    <Grid container>
      <Grid item xs={12} sm={4}>
        <Header dataTestId='filter-header' title={t('labor.employeeACAReportHeader')} isReportHeader />
      </Grid>
      <Grid item xs={12} paddingTop={3}>
        <ACAThresholdReportFilters
          filters={filters}
          setFilters={setFilters}
          hoursWorkedOptions={hoursWorkedOptions}
          showApproachingHourlyFilters={showApproachingHourlyFilters}
        />
      </Grid>
      <Grid item xs={12} paddingTop={1}>
        <Tabs value={tabPanel} onChange={handleChange}>
          <Tab label={t('labor.approachingACA.hourly.title')} data-testid='threshold-tab' />
          <Tab label={t('labor.employeeAverageHours')} data-testid='average-hours-tab' />
        </Tabs>
      </Grid>
      <Grid item xs={12}>
        <TabPanel value={tabPanel} index={0}>
          <Grid item xs={12}>
            <ACAHourlyThresholdDataGrid filters={filters} hoursWorked={hoursWorked} />
          </Grid>
        </TabPanel>
        <TabPanel value={tabPanel} index={1}>
          <Header
            dataTestId='aca-hourly-threshold-description'
            title=''
            description={t('labor.approachingACA.averageHours.description')}
          />
          <ACAAverageHoursDataGrid filters={filters} />
        </TabPanel>
      </Grid>
    </Grid>
  );
}

export default ACAThresholdReportDashboard;
